import { Box } from "@mui/material";
import Seo from "./../../components/Seo";
import FeaturedProjects from "./FeaturedProjects.jsx";
import ServicesHeroSection from "./ServicesHeroSection.jsx";
import ServicesOverview from "./ServicesOverview.jsx";
import ServicesCategories from "./ServicesCategories.jsx";
import ServicesVideoBanner from "./ServicesVideoBanner.jsx";
import ServicesProcessFlow from "./ServicesProcessFlow.jsx";
import ServicesFAQ from "./ServicesFAQ.jsx";
import ServicesEnquiryCTA from "./ServicesEnquiryCTA.jsx";

export default function ServicesPage() {
  return (
    <Box>
      <Seo
        title="Our Services – Metal Fabrication, Storage Tanks, Generator Enclosures & Engineering Solutions | Burj Al Yarmouk Industries LLC"
        description="Explore the wide range of metal fabrication and engineering services offered by Burj Al Yarmouk Industries LLC. We specialize in diesel storage tanks, STP tanks, fuel tanks, generator acoustic enclosures, skid frames, pipeline structures, steel platforms, custom fabrication work, and industrial engineering solutions across the UAE."
        url="https://burjalyarmouk.com/services"
        image="https://burjalyarmouk.com/og-banner.jpg"
        keywords="
    fabrication services uae,
    metal fabrication services abu dhabi,
    storage tank fabrication uae,
    generator acoustic enclosure fabrication,
    diesel tank manufacturing uae,
    STP tank fabrication uae,
    skid frame fabrication abu dhabi,
    steel structure fabrication uae,
    industrial fabrication services,
    pipeline structure fabrication,
    engineering solutions uae
  "
        schema={{
          "@context": "https://schema.org",
          "@type": "Service",
          provider: {
            "@type": "Organization",
            name: "Burj Al Yarmouk Industries LLC",
            url: "https://burjalyarmouk.com/",
            logo: "https://burjalyarmouk.com/favicon.ico",
          },
          serviceType: "Industrial Metal Fabrication & Engineering Services",
          description:
            "Burj Al Yarmouk Industries LLC provides professional metal fabrication, engineering solutions, and custom manufacturing services including diesel tanks, STP tanks, generator enclosures, pipeline structures, skid frames, and custom steel fabrication across the UAE.",
          areaServed: {
            "@type": "Country",
            name: "United Arab Emirates",
          },
          sameAs: [
            "https://www.instagram.com/burjalyarmouk/",
            "https://www.linkedin.com/in/burj-al-yarmouk-industries-llc-417570347/",
          ],
          hasOfferCatalog: {
            "@type": "OfferCatalog",
            name: "Burj Al Yarmouk – Services",
            itemListElement: [
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Storage Tank Fabrication",
                  description:
                    "Custom-built diesel, water, and fuel storage tanks designed and fabricated to international safety standards.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Generator Acoustic Enclosures",
                  description:
                    "High-quality soundproof generator enclosures ensuring noise reduction and safe operation.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "STP & Underground Tanks",
                  description:
                    "Fabrication of STP tanks, chemical tanks, and underground tanks with corrosion-resistant materials.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Skid Frames & Base Frames",
                  description:
                    "Heavy-duty skid structures suitable for machinery, generators, and industrial systems.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Pipeline & Structural Works",
                  description:
                    "Industrial pipeline fabrication, steel structures, frames, platforms, and custom steel works.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Custom Metal Fabrication",
                  description:
                    "Tailor-made fabrication jobs for industries requiring precision engineering and durable metalwork.",
                },
              },
            ],
          },
        }}
      />

      <ServicesHeroSection />
      <ServicesOverview />
      <ServicesCategories />
      {/* <FeaturedProjects /> */}
      <ServicesFAQ />
      <ServicesEnquiryCTA />
    </Box>
  );
}
